export const aloneColumns = [
  {
    title: "系统名称",
    width: 150,
    key: "systemName",
    slots: { customRender: "systemName" },
  },
  {
    title: "材料编号",
    width: 150,
    key: "materialNo",
    dataIndex: "materialNo",
  },
  {
    title: "材料名称",
    width: 150,
    key: "materialName",
    dataIndex: "materialName",
  },
  {
    title: "规格型号",
    width: 150,
    key: "materialModel",
    dataIndex: "materialModel",
  },
  {
    title: "品牌",
    width: 150,
    key: "materialBrand",
    dataIndex: "materialBrand",
  },
  {
    title: "结算单位",
    width: 150,
    key: "materialUnit",
    dataIndex: "materialUnit",
  },
  {
    title: "预算成本价(元)",
    width: 150,
    dataIndex: "costPrice",
    key: "costPrice",
    slots: { title: "costPriceTitle" },
  },
  {
    title: "市场销售价(元)",
    width: 150,
    dataIndex: "salesPrice",
    key: "salesPrice",
    slots: { title: "salesPriceTitle" },

  },
  {
    title: "预算单价（￥）",
    width: 150,
    key:'budgetPrice',
    slots: { customRender: "budgetPrice" },
  },
  {
    title: "申请数量",
    width: 150,
    key: "applyCount",
    dataIndex: "applyCount",
  },
  {
    title: "合同数量",
    width: 150,
    key: "count",
    dataIndex: "count",
  },
  {
    title: "合同单价-含税（￥）",
    width: 200,
    key:'taxPrice',
    slots: { customRender: "taxPrice" },
  },
  {
    title: "采购金额-含税（￥）",
    width: 200,
    key:'taxTotalPrice',
    slots: { customRender: "taxTotalPrice" },
  },
  {
    title: "采购金额-不含税（￥）",
    width: 200,
    key:'totalPrice',
    slots: { customRender: "totalPrice" },
  },
  {
    title: "描述",
    width: 200,
    key: "remark",
    dataIndex: "remark",
  },
];

export const frameColumns = [
  {
    title: "系统名称",
    width: 150,
    key: "systemName",
    slots: { customRender: "systemName" },
  },
  {
    title: "材料编号",
    width: 150,
    key: "materialNo",
    dataIndex: "materialNo",
  },
  {
    title: "材料名称",
    width: 150,
    key: "materialName",
    dataIndex: "materialName",
  },
  {
    title: "规格型号",
    width: 150,
    key: "materialModel",
    dataIndex: "materialModel",
  },
  {
    title: "品牌",
    width: 150,
    key: "materialBrand",
    dataIndex: "materialBrand",
  },
  {
    title: "结算单位",
    width: 150,
    key: "materialUnit",
    dataIndex: "materialUnit",
  },
  {
    title: "合同单价-含税（￥）",
    width: 200,
    key:'taxPrice',
    slots: { customRender: "taxPrice" },
  },
  {
    title: "合同单价-不含税（￥）",
    width: 200,
    key: "price",
    dataIndex: "price",
  },
  {
    title: "描述",
    width: 200,
    key:'remark',
    slots: { customRender: "remark" },
  },
];
